import { render, staticRenderFns } from "./DynamicTableHeader.vue?vue&type=template&id=5061d354&"
import script from "./DynamicTableHeader.vue?vue&type=script&lang=js&"
export * from "./DynamicTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTableHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports